import { Box, styled } from "@material-ui/core";

export const BoxConfirm = styled(Box)({
  borderRadius: "1rem",
  border: "2px solid #B5C9A8",
  background: "#F5F8F3",
  padding: "1.44rem 1.5rem 3.38rem"
});
